/**
 * Internal guard shared by `hasTemplate` and `interpolateObject` to decide
 * whether an object-typed value should be walked by the interpolation engine.
 *
 * Accepts plain objects (including `Object.create(null)`) and arrays; rejects
 * class instances, `Map`, `Set`, `Date`, typed arrays, and similar host
 * objects — the engine treats those as opaque leaves per ADR-12.
 *
 * Not part of the public interpolation API.
 */
export function isPlainArrayOrObject(value: object): boolean {
  if (Array.isArray(value)) {
    return true;
  }
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}
